import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=23cf59f8&scoped=true&"
var script = {}
import style0 from "./BlogHeader.vue?vue&type=style&index=0&id=23cf59f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf59f8",
  null
  
)

export default component.exports